import { WhoSubmitter } from '../../lib/who/who-submit.service'

export class DocsWhoSubmittter implements WhoSubmitter {
  public myChild(): void {
    alert('Navigates to child-info')
  }

  public myself(): void {
    alert('Navigates to self-info')
  }
}
